import { DatosExtra } from '../../types/Otros';
import { apiRequest } from '../Utils/apiClient';
import { GET_DATOS } from '../Utils/constants';

export const getDatosExtra = (): Promise<DatosExtra[] | undefined> =>
  apiRequest<DatosExtra[]>('get', GET_DATOS).then((res) => res.data);
